import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { AuthLayout } from "../components/AuthLayout";
import { Button, Field, Input, Alert, Spinner } from "../components/ui";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login({ email, password });
      navigate("/gear");
    } catch (err) {
      // Unverified accounts get bounced to the verify screen.
      if (err.status === 403 && err.data?.needsVerification) {
        navigate("/gear/verify", { state: { email, devCode: err.data.devCode } });
        return;
      }
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to the members-only gear marketplace."
      footer={
        <>
          <div>
            New here?{" "}
            <Link to="/gear/register" className="text-brand-600 font-semibold hover:underline">
              Create an account
            </Link>
          </div>
          <div className="mt-1">
            <Link
              to="/gear/forgot-password"
              className="text-brand-600 font-semibold hover:underline"
            >
              Forgot your password?
            </Link>
          </div>
        </>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Field label="Email">
          <Input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </Field>
        <Field label="Password">
          <Input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </Field>
        <Alert>{error}</Alert>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? <Spinner /> : "Sign in"}
        </Button>
      </form>
    </AuthLayout>
  );
}
